/**
 * @generated SignedSource<<8e00aec2e4e2d02156f37016fd5ac9eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatusGroupHeader$data = {
  readonly displayName: string;
  readonly statusCategory: {
    readonly statusCategoryId: string;
  };
  readonly " $fragmentType": "StatusGroupHeader";
};
export type StatusGroupHeader$key = {
  readonly " $data"?: StatusGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StatusGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCategoryId"
        }
      ]
    }
  ],
  "type": "JiraJqlStatusFieldValue"
};

(node as any).hash = "cdc8aa737da69440878c7ee8e5c447e6";

export default node;
